import React, {CSSProperties} from "react";
import {observer} from "mobx-react";
import {IBookingViewModel} from "../../../services/booking/models/booking-view-model.interface";
import {useServices} from "../../../hooks/use-services.hook";

export const TicketGrandTotalComponent: React.FC<{booking: IBookingViewModel;}> = observer((props) => {
    const services = useServices();
    const theme = services.theme.currentTheme;
    const styles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: theme.fontSize.h2,
        fontWeight: theme.fontWeight.bold,
        paddingLeft: theme.spacing.cardDefaultPadding,
        paddingRight: theme.spacing.cardDefaultPadding,
        pageBreakInside: "avoid",
        breakInside: "avoid",
        paddingTop: theme.spacing.spacing20
    }

    const amountStyles: CSSProperties = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing.flexGap8
    }

    return (
        <div style={styles}>
            <div style={amountStyles}>
                <span>
                    {services.language.translate('Balance due:')}
                </span>
                <span>
                    {props.booking.balanceDue.toString()}
                </span>
            </div>

            <div style={amountStyles}>
                <span>
                    {services.language.translate('Booking total:')}
                </span>
                <span>
                    {props.booking.shoppingCart.computedBookingTotal.toString()}
                </span>
            </div>
        </div>
    )

})